import { graphql, useMutation, UseMutationConfig, Disposable } from 'react-relay';
import { deleteWalletPaymentMethodMutation } from './__generated__/deleteWalletPaymentMethodMutation.graphql';

export const deleteWalletPaymentMethod = graphql`
    mutation deleteWalletPaymentMethodMutation($input: UserDeletePaymentMethodInput!) {
        userDeletePaymentMethod(input: $input) {
            user {
                wallet {
                    paymentMethods {
                        paymentMethod {
                            paymentProcessor
                            paymentMethodType
                            ... on CreditCard {
                                token
                                hashedCardNumber
                                ...WalletCreditCardOption_creditCard
                            }
                            ... on PayPalAccount {
                                token
                                email
                            }
                            ... on ACH {
                                token
                                ...WalletAchOption_ach
                            }
                        }
                        shippingAddresses {
                            serviceId
                        }
                    }
                }
            }
        }
    }
`;

export function useDeleteWalletPaymentMethodMutation(): [
    (config: UseMutationConfig<deleteWalletPaymentMethodMutation>) => Disposable,
    boolean
] {
    const [commitDeleteMutation, isInFlight] =
        useMutation<deleteWalletPaymentMethodMutation>(deleteWalletPaymentMethod);

    function commit(config: UseMutationConfig<deleteWalletPaymentMethodMutation>): Disposable {
        return commitDeleteMutation(config);
    }

    return [commit, isInFlight];
}
